module.exports = __webpack_public_path__ + "static/media/restart.880aaac8.png";